import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

export default function ScrollableTabsButtonAuto(_ref) {
    var selectedTabValue = _ref.selectedTabValue,
        handleItemClick = _ref.handleItemClick;


    var handleChange = function handleChange(event, newTab) {
        handleItemClick(newTab);
    };

    return React.createElement(
        Box,
        { sx: {
                maxWidth: { xs: 440, sm: 600, md: '100%' },
                margin: { md: '0 40px' },
                '@media only screen and (max-width: 899px)': {
                    margin: '0 30px'
                },
                '@media only screen and (max-width: 767px)': {
                    margin: '0 20px'
                },
                '@media only screen and (max-width: 474px)': {
                    margin: '0'
                },
                width: '100%',
                bgcolor: 'background.paper',
                '& .Mui-disabled': { width: '10px' }
            } },
        React.createElement(
            Tabs,
            {
                sx: { scrollButtons: true },
                value: selectedTabValue,
                onChange: handleChange,
                variant: 'scrollable',
                TabIndicatorProps: {
                    style: {
                        backgroundColor: "rgb(31, 107, 241)"

                    }
                }
                // scrollButtons
                , allowScrollButtonsMobile: true,
                'aria-label': 'scrollable auto tabs example'
            },
            React.createElement(Tab, { sx: { pl: { xs: 1, sm: 3, md: 5 }, pr: { xs: 1, sm: 3, md: 5 }, borderBottom: '1px solid #bdbdbd',
                    '&.Mui-selected': {
                        color: 'rgb(31, 107, 241)'
                    }
                }, label: 'Info', onClick: function onClick() {
                    return handleItemClick(0);
                } }),
            React.createElement(Tab, { sx: { pl: { xs: 1, sm: 5, md: 5 }, pr: { xs: 1, sm: 5, md: 5 }, borderBottom: '1px solid #bdbdbd',
                    '&.Mui-selected': {
                        color: 'rgb(31, 107, 241)'
                    }
                }, label: 'Image', onClick: function onClick() {
                    return handleItemClick(1);
                } }),
            React.createElement(Tab, { sx: { pl: { xs: 1, sm: 5, md: 5 }, pr: { xs: 1, sm: 5, md: 5 }, borderBottom: '1px solid #bdbdbd',
                    '&.Mui-selected': {
                        color: 'rgb(31, 107, 241)'
                    }
                }, label: 'Social', onClick: function onClick() {
                    return handleItemClick(2);
                } }),
            React.createElement(Tab, { sx: { pl: { xs: 1, sm: 5, md: 5 }, pr: { xs: 1, sm: 5, md: 5 }, borderBottom: '1px solid #bdbdbd',
                    '&.Mui-selected': {
                        color: 'rgb(31, 107, 241)'
                    }
                }, label: 'Design', onClick: function onClick() {
                    return handleItemClick(3);
                } }),
            React.createElement(Tab, { sx: { pl: { xs: 1, sm: 5, md: 5 }, pr: { xs: 1, sm: 5, md: 5 }, borderBottom: '1px solid #bdbdbd',
                    '&.Mui-selected': {
                        color: 'rgb(31, 107, 241)'
                    }
                }, label: 'Template', onClick: function onClick() {
                    return handleItemClick(4);
                } })
        )
    );
}


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/components/ScrollableTabsButtonAuto.js